<template>
  <div class="report-list">
    <s-table
      class="report-list__table"
      :items="items"
      :fields="fields"
      :busy="loading"
    >
      <template #cell(carregarInformacoesAtuais)="data">
        {{ data.item.carregarInformacoesAtuais ?
            $t('engineering.templates-simulation.list.yes') :
            $t('engineering.templates-simulation.list.no') }}
      </template>
      <template #cell(actions)="data">
        <b-button
          size="sm"
          variant="primary"
          @click="viewSimulation(data.item)"
        >
          {{ $t('general.view') }}
        </b-button>
        <b-dropdown
          right
          no-caret
          offset="-15"
          variant="link"
          class="report-list__options-btn"
          boundary="window"
        >
          <template slot="button-content">
            <s-loader v-if="isReportLoading(data.item.id)"/>
            <i
              v-else
              aria-hidden="true"
              class="fas fa-ellipsis-v text-gray"
            />
          </template>
          <b-dropdown-item
            v-for="({
              label,
              itemClass,
              iconClass,
              click,
            }) in dropdownItems"
            :key="label"
            :class="itemClass"
            @click="click(data.item)"
          >
            <span
              class="report-list__option-icon text-center"
              :class="iconClass"
            />
            {{ label }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </s-table>
    <grid-paginator
      v-model="pageHandler"
      :per-page="pagination.pageSize"
      :total-rows="pagination.totalRows"
    />
  </div>
</template>

<script>
import GridPaginator from '@/components/lists/Paginator';

export default {
  components: {
    GridPaginator,
  },
  props: {
    loading: {
      type: Boolean,
    },
    items: {
      type: Array,
    },
    pagination: {
      type: Object,
      default: () => ({
        perPage: 10,
        currentPage: 1,
        totalRows: null,
      }),
    },
  },
  data() {
    return {
      loadingDropdown: '',
    };
  },
  computed: {
    pageHandler: {
      get() {
        return this.pagination.currentPage;
      },
      set(value) {
        this.$emit('update:currentPage', value);
      },
    },
    dropdownItems() {
      return [
        {
          itemClass: 'report-list__option-export',
          iconClass: 'fas fa-file-excel',
          label: this.$t('engineering.templates-simulation.list.export-xlsx'),
          click: this.exportXlsx,
        },
        {
          itemClass: 'report-list__option-edit',
          iconClass: 'fas fa-pencil-alt',
          label: this.$t('engineering.templates-simulation.list.edit'),
          click: this.editSimulation,
        },
        {
          itemClass: 'report-list__option-delete',
          iconClass: 'fas fa-trash-alt',
          label: this.$t('engineering.templates-simulation.list.delete'),
          click: this.confirmDeleteTemplate,
        },
      ];
    },
    fields() {
      return [
        {
          key: 'nome',
          label: this.$t('engineering.templates-simulation.list.template'),
        },
        {
          key: 'ativoOrigem',
          label: this.$t('engineering.templates-simulation.list.source-asset'),
        },
        {
          key: 'quantidadePontos',
          label: this.$t('engineering.templates-simulation.list.points'),
        },
        {
          key: 'actions',
          label: '',
          class: 'report-list__cell-actions',
        },
      ];
    },
  },
  methods: {
    isReportLoading(id) {
      return this.loadingDropdown === id;
    },
    viewSimulation(simulation) {
      this.$emit('viewSimulation', simulation);
    },
    exportXlsx(simulation) {
      this.$emit('exportXls', simulation);
    },
    editSimulation(simulation) {
      this.$emit('editSimulation', simulation);
    },
    confirmDeleteTemplate(item) {
      this.$confirmMessage({ code: 'MC011' }).accepted(() => {
        this.$emit('deleteTemplate', item);
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  .report-list
    display: flex
    flex-direction: column
    ::v-deep
      .btn.dropdown-toggle.btn-link.dropdown-toggle-no-caret:hover,
      .btn.dropdown-toggle.btn-link.dropdown-toggle-no-caret:focus
        text-decoration: none
    &__table
      flex: 1
      min-height: 48vh
    &__options-btn
      margin: -10px 0
    &__option-icon
      margin-right: 5px
    ::v-deep &__option
      &-export a
        color: var(--color-primary)
      &-delete a
        color: var(--color-danger)
    ::v-deep &__cell
      &-report-name
        min-width: 100px
        width: 20%
      &-installations
        width: 25%
      &-asset-type
        width: 25%
      &-asset
        width: 10%
      &-actions
        min-width: 15em
        width: 15%
</style>
